import React from 'react';
import '../App.css';
import pkg from '../../package.json';
import { Link } from 'react-router-dom';

function Footer() {
  return (
    <nav
      className="navbar fixed-bottom p-2 d-flex justify-content-between"
      style={{
        background: 'linear-gradient(to top, #f8f9fa, #e9ecef)',
        boxShadow: '0 -2px 4px rgba(0,0,0,0.1)',
        height: '50px',
      }}
    >
      <span className="navbar-text">
        Test Catalog version{' '}
        <Link to="/changelog" className="text-decoration-underline">
          {pkg.version}
        </Link>
      </span>
      <span className="navbar-text">
        Please provide feedback and any specific requests to{' '}
        <a href="mailto:sebastian.chlad@suse.com">schlad</a>
      </span>
    </nav>
  );
}

export default Footer;
